import React, { useState, useEffect, useRef } from 'react';
import { Input, Message, Form, Divider, Checkbox, Icon, Button } from '@alifd/next';
import { useInterval } from './utils';
import styles from './index.module.scss';
import client from '../../../../lib/feathers';
import { history } from 'ice';
import axios from "axios";


const { Item } = Form;
const DEFAULT_DATA = {
  email: '',
  // password: '',
  // autoLogin: true,
  // phone: '',
  code: '',
};

const ResetPasswordVerifyBlock = (
  props = {
    dataSource: DEFAULT_DATA,
  },
) => {
  const { dataSource = DEFAULT_DATA } = props;

  const [username, setUsername] = useState("");
  const [postData, setValue] = useState(dataSource);

  const [isRunning, checkRunning] = useState(false);
  const [isPhone, checkPhone] = useState(false);
  const [second, setSecond] = useState(10);
  const [sendEmail, setSendEmail] = useState("");
  const [code, setCode] = useState(null);
  const [resetPasswordStatus, setResetPasswordStatus] = useState(false);
  // console.log(sendEmail)

  // const sendEmail = useRef(null);

  useInterval(
    () => {
      setSecond(second - 1);

      if (second <= 0) {
        checkRunning(false);
        setSecond(10);
      }
    },
    isRunning ? 1000 : null,
  );

  const formChange = values => {
    // console.log(values)
    setValue(values);
  };

  const sendCode = (values, errors) => {
    setValue(values)
    setSendEmail(values.email)
    console.log(values)

    if (errors) {
      return;
    }

    checkRunning(true);

    try {
      if (values.email) {
        axios('/ezcon/api/sendMail', {
          method: "POST",
          // headers:{ authorization: window.localStorage['feathers-jwt'] },
          data: { email: values.email }
        }).then((res) => {
          console.log('Success:', res);
          if (res.status === 200) {
            Message.success('傳送成功');

          }
        }).catch(error => {
          console.error('Error', error);
          Message.error('傳送失敗');
        })
      }
    } catch (error) {
      console.log("Error:", error)
    }
  };





  const handleSubmit = (values, errors) => {
    setSendEmail(values.email)
    setCode(values.code)
    if (errors) {
      console.log('errors', errors);
      return;
    }
    console.log('values:', values);
    // console.log('sendEmail:', sendEmail);
    try {
      if (sendEmail && values.code) {
        axios('/ezcon/api/verifyNumber', {
          method: "POST",
          // headers:{ authorization: window.localStorage['feathers-jwt'] },
          data: { email: sendEmail, code: values.code }
        }).then((res) => {
          console.log('Success:', res);
          if (res.status === 200) {
            Message.success('驗證成功');
            setResetPasswordStatus(true)

          }
        }).catch(error => {
          console.error('Error', error);
          Message.error('驗證失敗');
        })
      }
      if (values.password && values.rePassword) {
        axios('/ezcon/api/resetPasswordVerify', {
          method: "POST",
          // headers:{ authorization: window.localStorage['feathers-jwt'] },
          data: { password: values.password, code: code, email: sendEmail }
        }).then((res) => {
          console.log('Success:', res);
          if (res.status === 200) {
            Message.success('儲存成功');
            if (history.location.pathname === `/mobile/user/resetPasswordVerify`) {
              history.push('/mobile/user/login');
            } else {
              history.push('/user/login')
            }

          }
        }).catch(error => {
          console.error('Error', error);
          Message.error('變更失敗');
        })
      }
    } catch (error) {
      console.log("Error:", error)
    }



  };

  const checkPass = (rule, values, callback) => {
    if (values && values !== postData.password) {
      return callback('密碼不一致');
    }
    return callback();
  };



  const codeForm = (
    <>

      <Item
        format="email"
        required
        requiredMessage="必填"
        style={{
          marginBottom: 0,
        }}
      >
        <Input
          name="email"
          innerAfter={
            <span className={styles.innerAfterInput}>
              <span className={styles.line} />
              <Form.Submit
                text
                type="primary"
                style={{
                  width: 64,
                }}
                disabled={!!isRunning}
                validate={['phone']}
                onClick={sendCode}
                className={styles.sendCode}
              >
                {isRunning ? `${second}秒後再試` : '獲取驗證'}
              </Form.Submit>
            </span>
          }
          maxLength={50}
          placeholder="請輸入註冊過信箱"
        />
      </Item>
      <div style={{ height: '10px' }}></div>
      <Item format="number" required requiredMessage="必填" formatMessage="只限數字" >
        <Input
          name="code"
          maxLength={4}
          placeholder="請輸入驗證碼"
        />
      </Item>
    </>
  );
  const accountForm = (
    <>
      <Item label="" required requiredMessage="必填" >
        <Input.Password
          name="password"
          size="large"
          // htmlType="password"
          placeholder="重設新密碼"
        />
      </Item>
      <Item label="" required requiredTrigger="onFocus" requiredMessage="必填" validator={checkPass} >
        <Input.Password
          name="rePassword"
          size="large"
          htmlType="password"
          placeholder="確認新密碼"
        // onKeyDown={(e)=>{
        //   if(e.key==='Enter'){
        //     handleSubmit(postData)
        //   }
        // }}
        />
      </Item>


      {/* <Item
        required
        requiredMessage="必填"
        style={{
          marginBottom: 0,
        }}
      >
        <Input.Password 
      
        name="password" 
        htmlType="password" 
        placeholder="密碼" 
        onKeyDown={(e)=>{
          if(e.key==='Enter'){
            handleSubmit(postData)
          }
        }}

        />
    
      </Item>
      <div style={{height:'30px'}}></div> */}
    </>
  );

  const byAccount = () => {
    checkPhone(false);
  };

  const byForm = () => {
    checkPhone(true);
  };


  return (
    <>
      {history.location.pathname === `/mobile/user/resetPasswordVerify` ?
        <div className={styles.mobileResetPassword}>
          <div className={styles.mobileResetPasswordBackground} />
          <div className={styles.mobileResetPasswordContainer}>
  
              <div className={styles.mobileAccountText}>
                {/* <span onClick={byAccount} className={styles.active}> */}
                  {resetPasswordStatus === true ? "密碼修改" : "信箱驗證"}
                {/* </span> */}
          
              </div>

              <Form value={postData} onChange={formChange} size="large">

                {resetPasswordStatus === true ? accountForm : codeForm}


               
                {/* <div style={{ height: '10px' }}></div> */}
                <Item
                  style={{
                    marginBottom: 10,
                  }}
                >
                  <Form.Submit

                    type="primary"
                    onClick={handleSubmit}
                    className={styles.mobileSubmitBtn}
                    validate
                  >
                    {resetPasswordStatus === true ? "提交" : "重設密碼"}
                  </Form.Submit>
                </Item>
                <div className={styles.mobileLinkBox}>
             
                  {/* <div style={{ height: '10px' }}></div> */}

                  <a onClick={() => {
                    if (history.location.pathname === `/mobile/user/resetPasswordVerify`) {
                      history.push('/mobile/user/login');
                    } else {
                      history.push('/user/login')
                    }
                  }} className={styles.mobileLink}>
                    返回
                 </a>

                </div>
              </Form>
            
          </div>
        </div>


        :
        <div className={styles.LoginBlock}>

          <div className={styles.innerBlock}>
            {/* <a href="#">
          <img
            className={styles.logo}
            src="https://img.alicdn.com/tfs/TB1KtN6mKH2gK0jSZJnXXaT1FXa-1014-200.png"
            alt="logo"
          />
        </a> */}
            <div className={styles.desc}>
              <span onClick={byAccount} className={styles.active}>
                {resetPasswordStatus === true ? "密碼修改" : "信箱驗證"}
              </span>
              {/* <Divider direction="ver" /> */}
              {/* <span onClick={byForm} className={isPhone ? styles.active : undefined}>
            手机号登录
          </span> */}
            </div>

            <Form value={postData} onChange={formChange} size="large">

              {resetPasswordStatus === true ? accountForm : codeForm}


              {/* phoneForm */}

              {/* <div className={styles.infoLine}>
            <Item
              style={{
                marginBottom: 0,
             
              }}
            >
              <Checkbox name="autoLogin" className={styles.infoLeft}>
                自動登入
              </Checkbox>
            </Item>
            <div >
              <a href="#/user/register" className={styles.link}>
                忘記密碼
              </a>
            </div>
          </div> */}
              <div style={{ height: '10px' }}></div>
              <Item
                style={{
                  marginBottom: 10,
                }}
              >
                <Form.Submit

                  type="primary"
                  onClick={handleSubmit}
                  className={styles.submitBtn}
                  validate
                >
                  {resetPasswordStatus === true ? "提交" : "重設密碼"}
                </Form.Submit>
              </Item>
              <div className={styles.infoLine}>
                {/* <div className={styles.infoLeft}>
              其他方式登入 <Icon type="atm" size="small" /> <Icon type="atm" size="small" />{' '}
              <Icon type="atm" size="small" />
            </div> */}
                <div style={{ height: '10px' }}></div>

                <a onClick={() => {
                  if (history.location.pathname === `/mobile/user/resetPasswordVerify`) {
                    history.push('/mobile/user/login');
                  } else {
                    history.push('/user/login')
                  }
                }} className={styles.link}>
                  返回
            </a>

              </div>
            </Form>
          </div>
        </div>
      }</>);
};

export default ResetPasswordVerifyBlock;